// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  width: 100%;
  padding: 0.5em;
}
.location-grid {
  border: 2px solid var(--eta-color-theme);
  border-radius: 1rem;
  padding: 0.4rem;
}
.location-grid .filter-options {
  background: #fff;
}
/*# sourceMappingURL=ToHkustPage.css.map */`, "",{"version":3,"sources":["webpack://./ToHkustPage.less","webpack://./src/containers/ToHkustPage/ToHkustPage.less"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,cAAA;ACCJ;ADEA;EACI,wCAAA;EACA,mBAAA;EACA,eAAA;ACAJ;ADHA;EAMQ,gBAAA;ACAR;AACA,0CAA0C","sourcesContent":[".container {\n    width: 100%;\n    padding: .5em;\n}\n\n.location-grid {\n    border: 2px solid var(--eta-color-theme);\n    border-radius: 1rem;\n    padding: .4rem;\n\n    .filter-options {\n        background: #fff;\n    }\n}\n",".container {\n  width: 100%;\n  padding: 0.5em;\n}\n.location-grid {\n  border: 2px solid var(--eta-color-theme);\n  border-radius: 1rem;\n  padding: 0.4rem;\n}\n.location-grid .filter-options {\n  background: #fff;\n}\n/*# sourceMappingURL=ToHkustPage.css.map */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
